<template>
    <div class="container">
        <!-- <div class="summary">
            <a-statistic
                title="申请中的提现金额（元）"
                :value="data_summary.amount"
                style="margin-right: 50px"
            />

            <a-statistic
                title="申请中的提现订单量"
                :value="data_summary.amount_pend"
                style="margin-right: 50px"
            />
        </div> -->
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" ref="refresh" icon="icon icon-reset" @click="load()" />
                <a-divider type="vertical" class="item" />

                <a-radio-group v-model="status" button-style="solid" @change="(e) => on_status_change(e, 'status')">
                    <a-radio-button value>全部</a-radio-button>
                    <a-radio-button value="0">处理中</a-radio-button>
                    <a-radio-button value="1">已提现</a-radio-button>
                    <a-radio-button value="-1">已失败</a-radio-button>
                </a-radio-group>
            </div>

            <div class="right-items">
                <!-- <a-input-search
                    placeholder="搜索单号"
                    enter-button
                    @search="on_search"
                    class="item"
                    v-model="wd"
                />-->
            </div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
                :scroll="{ x: true }"
            >
                <template slot="sort" slot-scope="text, record, index">
                    <div class="sort">
                        <a-button
                            shape="circle"
                            icon="arrow-down"
                            size="small"
                            @click="on_sort(record, 'down', index)"
                            v-if="index != data_source.length - 1"
                        />
                        <a-button shape="circle" icon="arrow-up" size="small" @click="on_sort(record, 'up', index)" v-if="index != 0" />
                    </div>
                </template>

                <template slot="status" slot-scope="text, record">
                    <a-tag class="b-tag" v-if="text == 0">处理中</a-tag>
                    <a-tag color="green" class="b-tag" v-if="text == 1">已完成</a-tag>
                    <a-tag color="red" class="b-tag" v-if="text == -1">失败</a-tag>
                </template>

                <template slot="member" slot-scope="text">
                    <div class="tbox" v-if="text">
                        <div class="a">{{ text.name }}</div>
                        <div class="b">ID：{{ text.id }}</div>
                    </div>
                </template>

                <!-- 处理人 -->
                <template slot="executor" slot-scope="text, record">
                    <div class="tbox">
                        <div class="a">
                            {{ record.executor ? record.executor.name : "-" }}
                        </div>
                        <div class="b" v-if="record.executed_at">
                            {{ moment(record.executed_at * 1000).format("YYYY-MM-DD HH:mm") }}
                        </div>
                    </div>
                </template>

                <template slot="action" slot-scope="text, record">
                    <a-button size="small" @click="on_ok(record)" :disabled="record.status != 0">通过</a-button>
                    <a-divider type="vertical" />
                    <a-button size="small" @click="on_cancel(record)" :disabled="record.status != 0">拒绝</a-button>
                </template>
            </a-table>
        </div>

        <!-- 通过付款申请 -->
        <a-modal
            :centered="true"
            title="通过提现申请"
            :visible="visible_ok"
            :confirm-loading="submitting"
            @ok="ok_submit"
            width="360"
            @cancel="visible_ok = false"
        >
            <a-descriptions size="small" bordered :column="1" v-if="selected_record">
                <a-descriptions-item label="提现单号">
                    {{ selected_record.withdraw_no }}
                </a-descriptions-item>
                <a-descriptions-item label="提现金额">
                    {{ selected_record.amount }}
                </a-descriptions-item>
                <a-descriptions-item label="申请人">
                    {{ selected_record.member.name }}
                </a-descriptions-item>
            </a-descriptions>
        </a-modal>

        <!-- 通过付款申请 -->
        <a-modal
            title="拒绝提现申请"
            :centered="true"
            width="360"
            :visible="visible_cancel"
            :confirm-loading="submitting"
            @ok="cancel_submit"
            @cancel="visible_cancel = false"
        >
            <a-descriptions size="small" bordered :column="1" v-if="selected_record" style="margin-bottom:24px">
                <a-descriptions-item label="提现单号">
                    {{ selected_record.withdraw_no }}
                </a-descriptions-item>
                <a-descriptions-item label="提现金额">
                    {{ selected_record.amount }}
                </a-descriptions-item>
                <a-descriptions-item label="申请人">
                    {{ selected_record.member.name }}
                </a-descriptions-item>
            </a-descriptions>

            <a-form-model>
                <a-form-model-item label="请填写拒绝原因">
                    <a-textarea v-model="cancel_content"></a-textarea>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";
    import commonjs from "../mixins/common";

    export default {
        mixins: [common_pagination, commonjs],
        data() {
            return {
                path: "/finance/withdraw",
                data_source: [],
                loading: false,
                selected_record: null,
                wd: null,
                status: "",
                submitting: false,
                visible_ok: false,
                visible_cancel: false,
                cancel_content: null,
                data_summary: {
                    amount: 0,
                    amount_pend: 0,
                    amount_succeed: 0,
                },
                columns: [
                    {
                        dataIndex: "status",
                        width: 80,
                        title: "提现状态",
                        fixed: "left",
                        align: "center",
                        scopedSlots: {
                            customRender: "status",
                        },
                    },
                    {
                        dataIndex: "withdraw_no",
                        width: 180,
                        title: "提现单号",
                        fixed: "left",
                    },
                    {
                        dataIndex: "payment",
                        width: 150,
                        title: "付款单号",
                    },
                    {
                        dataIndex: "amount_apply",
                        width: 120,
                        title: "申请金额",
                        customRender: (e) => `¥ ${e || "-"}`,
                    },
                    {
                        dataIndex: "amount",
                        width: 120,
                        title: "到账金额",
                        customRender: (e) => `¥ ${e || "-"}`,
                    },
                    {
                        dataIndex: "amount_fee",
                        width: 120,
                        title: "提现费用/元",
                        customRender: (e) => `¥ ${e || "-"}`,
                    },
                    {
                        dataIndex: "fee_explain",
                        width: 120,
                        title: "费用说明",
                        customRender: (e) => e || "-",
                    },
                    {
                        dataIndex: "member",
                        width: 100,
                        title: "提现客户",
                        scopedSlots: {
                            customRender: "member",
                        },
                    },
                    {
                        dataIndex: "executor",
                        width: 120,
                        title: "处理人",
                        scopedSlots: {
                            customRender: "executor",
                        },
                    },
                    {
                        dataIndex: "created_at",
                        width: 130,
                        title: "提现时间",
                        customRender: (e) => (e ? moment(e * 1000).format("YYYY-MM-DD HH:mm") : ""),
                    },
                    {
                        dataIndex: "remark",
                        title: "备注",
                    },
                    {
                        dataIndex: "response_msg",
                        title: "提现结果",
                    },
                    {
                        dataIndex: "action",
                        width: 130,
                        align: "center",
                        title: "操作",
                        fixed: "right",
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
            };
        },
        mounted() {
            this.load();

            this.load_summary();
        },
        watch: {
            $route() {
                this.load();
            },
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/finance/withdraw?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };

                            this.load_stat();
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            load_summary() {
                this.$http
                    .get(`/finance/withdraw/summary`)
                    .then((res) => {
                        if (res.success) {
                            this.data_summary = res.data;
                        }
                    })
                    .catch(() => {})
                    .then(() => {});
            },
            on_status_change(e, field) {
                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                new_query[field] = e.target.value;
                this.$router.push(this.path + "?" + this.objectToQuery(new_query));
            },
            on_ok(record) {
                this.selected_record = record;
                this.visible_ok = true;
            },
            on_cancel(record) {
                this.selected_record = record;
                this.visible_cancel = true;
            },
            ok_submit() {
                this.submitting = true;

                this.$http
                    .post(`/finance/withdraw/approve`, { withdraw_no: this.selected_record.withdraw_no })
                    .then((res) => {
                        if (res.success) {
                            this.load();
                            this.$message.success(res.message);
                            this.visible_ok = false;
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
            cancel_submit() {
                if (!this.cancel_content) {
                    this.$message.error("请填写拒绝原因");
                    return false;
                }
                this.submitting = true;
                this.$http
                    .post(`/finance/withdraw/cancel`, { withdraw_no: this.selected_record.withdraw_no, content: this.cancel_content })
                    .then((res) => {
                        if (res.success) {
                            this.load();
                            this.$message.success(res.message);
                            this.visible_cancel = false;
                            this.cancel_content = null;
                        } else {
                            this.$error({ title: "失败", centered: true, content: res.message });
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.submitting = false;
                    });
            },
        },
    };
</script>

<style lang="less" scoped>
    .container {
        .summary {
            padding: 16px;
            border-bottom: 1px solid #e8e8e8;
            box-sizing: border-box;
            display: flex;
            align-items: center;
        }
        .main {
            // top: 150px !important;
        }
    }
</style>
